import * as c from './types';

import createReducer from '../../reducers/utils/createReducer';

const initialState = {
  data: [],
  isLoading: false,
  isLoadingEditions: false,
  error: null,
  companySchedule: [],
  individualEditions: []
};

export default createReducer(initialState, {
  [c.GET_SCHEDULE_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.GET_SCHEDULE_SUCCESS]: (state, { payload }) => ({
    ...state,
    data: payload,
    isLoading: false
  }),
  [c.GET_SCHEDULE_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),

  // Create or Update Custom
  [c.SUBMIT_CUSTOM_SHIFT_SCHEDULE_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.SUBMIT_CUSTOM_SHIFT_SCHEDULE_SUCCESS]: (state, { payload }) => ({
    ...state,
    items: payload,
    isLoading: false
  }),
  [c.SUBMIT_CUSTOM_SHIFT_SCHEDULE_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),
  [c.GET_COMPANY_SCHEDULE_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.GET_COMPANY_SCHEDULE_SUCCESS]: (state, { payload }) => ({
    ...state,
    companySchedule: payload,
    isLoading: false
  }),
  [c.GET_COMPANY_SCHEDULE_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),

  [c.SAVE_COMPANY_SCHEDULE_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoading: true
  }),
  [c.SAVE_COMPANY_SCHEDULE_SUCCESS]: (state) => ({
    ...state,
    isLoading: false
  }),
  [c.SAVE_COMPANY_SCHEDULE_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false
  }),

  [c.LIST_SHIFT_INDIVIDUAL_EDITIONS_REQUEST]: (state) => ({
    ...state,
    error: null,
    isLoadingEditions: true
  }),
  [c.LIST_SHIFT_INDIVIDUAL_EDITIONS_SUCCESS]: (state, { payload }) => ({
    ...state,
    isLoadingEditions: false,
    individualEditions: payload
  }),
  [c.LIST_SHIFT_INDIVIDUAL_EDITIONS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoadingEditions: false
  })
});
